import React, { useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import { PngImages, SvgImages } from "../../Utils/LocalImages";
import Image from "../../Components/Reusable/Image";
import AuthLayout from "../../Components/Layouts/Authlayout";
import { useLocation, useNavigate } from "react-router-dom";
import { SubTitleLabel, TitleLabel } from "../../Components/Reusable/LabelComponents";
import RoutesPath from "../../Utils/RoutesPath";
import { handleApiErrors } from "../../Utils/Utils";
import SubmitButtonTwo from "../../Components/Reusable/Buttontwo";
import { OtpVerificationType } from "../../Utils/Enums";
import StudentDashboardServices from "../../Services/StudentDashboardApiService";
import CoAuthLayout from "../../Components/Layouts/CoAuthlayout";
import CoordinatorApiServices from "../../Services/CoordinatorApiServices";

const CoordinatorOtpVarify = () => {
  const propData = useLocation().state;  // get email from local storage for verification purpose
  const navigate = useNavigate();
  const inputRefs = useRef([]);
  const otpCount = 6;
  const timerInterval = 120;
  const [timeLeft, setTimeLeft] = useState(timerInterval); // 120 seconds
  const [timer, setTimer] = useState();
  const [resendOTPEnabled, setResendOTPEnabled] = useState(false);


  const startOtpCountDown = () => {
    setResendOTPEnabled(false);

    setTimeLeft(timerInterval);
    clearInterval(timer);
    setTimer(
      setInterval(() => {
        setTimeLeft((prevTime) => {
          if (prevTime <= 1) {
            clearInterval(timer);
            setResendOTPEnabled(true);

            return 0;
          }
          return prevTime - 1;
        });
      }, 1000)
    );
    return () => clearInterval(timer);
  };

  useEffect(() => {
    startOtpCountDown();

    // Cleanup on component unmount
    return () => clearInterval(timer);
  }, []);

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${String(minutes).padStart(2, "0")}:${String(
      remainingSeconds
    ).padStart(2, "0")}`;
  };

  // Function to handle input change
  const handleChange = (event, index) => {
    const value = event.target.value;

    if (value && index === inputRefs.current.length - 1) {
      handleOtpSubmit();
      return;
    }

    // Ensure input is a single digit
    if (/^\d$/.test(value)) {
      // Move focus to next input
      if (value && index < inputRefs.current.length - 1) {
        inputRefs.current[index + 1].focus();
      }
    }
  };

  const handleKeyPress = (index, event) => {
    if (event.key === "Backspace" && index > 0) {
      if (
        index === inputRefs.current.length - 1 &&
        inputRefs.current[index].value !== ""
      ) {
        inputRefs.current[index].value = "";
        return;
      }
      inputRefs.current[index - 1].focus();
    }
  };

  const getOtpValue = () => {
    return inputRefs.current
      .map((e) => e.value)
      .join("")
      .toString();
  };

  const clearOtpFields = () => {
    inputRefs.current.forEach((input) => {
      if (input) input.value = ""; // Clear each input field
    });
    inputRefs.current[0].focus(); // Focus on the first input
  };


  const resendOtp = async () => {
    try {
      if (propData.type === OtpVerificationType.login) {
        const response = await CoordinatorApiServices.coordinatorlogin(propData.email, propData.password);
        toast.success(`OTP resent successfully`);
      } else if (propData.type === OtpVerificationType.forgotPassword) {
        const response = await CoordinatorApiServices.coforgotPassword(propData.email);
        toast.success(`OTP resent successfully`);
      }
      clearOtpFields();
      startOtpCountDown();
    } catch (error) {
      handleApiErrors(error);
    }
  };

  const handleOtpSubmit = async () => {
    const otp = getOtpValue().trim();
    if (!otp.trim() || otp.length !== otpCount) {
      toast.warning("OTP must be " + otpCount.toString() + " digits");
      return;
    }
    try {
      const response = await CoordinatorApiServices.verifyOTP(propData.email, otp, propData.type);
      toast.success(response.message);
      navigate(propData.type === OtpVerificationType.forgotPassword ? RoutesPath.coresetPassword : RoutesPath.dashboardcoordinator);
    } catch (error) {
      handleApiErrors(error);
    }
  };

  return (
    <CoAuthLayout>
      <div className="col-md-7 m-auto login_box px-1">
        <div className="d-flex justify-content-center login_logo">
          <Image src={SvgImages.logo} className="img-fluid" style={{ height: "70px" }} />
        </div>

        <div className="mb-4 text-center">
          <TitleLabel text={"OTP Verification"} />
          <SubTitleLabel text={"Please provide your otp verification"} />
        </div>

        <div className="p-0 mb-4">
          <div className="d-flex gap_16 justify-content-between">
            {[...Array(otpCount)].map((_, index) => (
              <input
                key={index}
                ref={(ref) => (inputRefs.current[index] = ref)}
                type="text"
                className="otp_number_Co"
                onChange={(event) => handleChange(event, index)}
                onKeyDown={(e) => handleKeyPress(index, e)}
                maxLength={1}
              />
            ))}
          </div>
        </div>
        <div className="d-flex justify-content-center ">
          <SubmitButtonTwo title={"Verify my email"} className="w-100 fw-700 cologinbtn" onclick={handleOtpSubmit} />
        </div>
        <div className="d-flex align-items-center mt-4">
          <div className=" fw-600 small-text w-25 "
            style={{ opacity: resendOTPEnabled ? 0 : 1, color: '#14489f' }}>
            {formatTime(timeLeft)}
          </div>

          <div className="text-center ">
            <h4 className="small-medium-text fw-600 black mb-0" >Didn’t get the code? <span className="blue cursor-pointer"
              style={{ opacity: resendOTPEnabled ? 1 : 0.5 }}
              onClick={() => {
                if (resendOTPEnabled) {
                  resendOtp();
                }
              }}>Resend otp</span></h4>
          </div>
        </div>
      </div>
    </CoAuthLayout>
  );
};

export default CoordinatorOtpVarify;
